import * as React from 'react';
import { observer } from "mobx-react";
import { DataTableView, Column } from 'src/core/ui/data-table.view';

interface AllotmentAllotmentRangeViewProps extends ComponentViewProps<AllotmentItem> {
    mode: ControlMode;
    dataService: DataSet<AllotmentRangeItem>;
    onItemDoubleClicked?: (item: AllotmentRangeItem) => any;
}

@observer
export class AllotmentAllotmentRangeView extends React.Component<AllotmentAllotmentRangeViewProps, any> {
   
    public constructor(props) {
        super(props);
    }
    public render() {
        const model = this.props.model;
        const dataService = this.props.dataService;
        const columns: Column[] = [
            {
                key: 'dateFromToText',
                title: 'Date From',
                dataIndex: 'dateFromToText' 
            },
            {
                key: 'dateToToText',
                title: 'Date To ',
                dataIndex: 'dateToToText' 
            },
            {
                key: 'totalLimit',
                title: 'Total Limit',
                dataIndex: 'totalLimit' 

            }, {
                key: 'dailyLimit',
                title: 'Daily Limit',
                dataIndex: 'dailyLimit' 
            }
            , {
                key: 'allotmentRangeTypeToText',
                title: 'Type',
                dataIndex: 'allotmentRangeTypeToText'
            }
        ];
        return (
            <DataTableView
                mode={this.props.mode}
                createNewItem={() => this.props.onItemDoubleClicked(null)}
                setBusy={this.props.setBusy}
                columns={columns}
                model={dataService}
                itemDoubleClick={(item) => { if (this.props.onItemDoubleClicked) { this.props.onItemDoubleClicked(item); } }} />
        )
    }
  
}



// WEBPACK FOOTER //
// ./src/app/products/allotment/form/parts/allotment-allotmentrange.view.tsx